// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// We will improve the folder structure as we add components
import '@automator/builder/_legacy/js/item/conditions/components';
import '@automator/builder/_legacy/js/user-selector/components';

// Load walkthrough
import '@automator/builder/_legacy/js/walkthrough';

// Load static resources
// Import select2 (Dropdown)
// select2.org
import "select2/dist/css/select2.css";

// Import flatpickr (DatePicker)
// flatpickr.js.org
import "flatpickr/dist/flatpickr.min.css";

// Import main styles
import './scss/main.scss';

import {
	createDataOnLoad,
	handleFatalError
}   from './js/common/utilities.js';

import Publish            from './js/publish/publish.js';

import Triggers           from './js/item/triggers.js';
import Actions            from './js/item/actions.js';

import SendFeedback       from './js/send-feedback/send-feedback.js';

import RecipeTitle        from './js/recipe/title';

import Taxonomies         from './js/taxonomies/taxonomies.js';

import RecipeNotes        from './js/recipe/notes';

if ( ! isEmpty(UncannyAutomator ) ) {
	// Create JS cache object
	UncannyAutomator._cache = {
		tokens: {},
	};

	// Create the data required to render Automator
	try {
		createDataOnLoad(() => {
			// Once ready, render the UI
			new Triggers();
			new Actions();
			new Publish();
			new SendFeedback();
			new RecipeTitle();
			new Taxonomies();
			new RecipeNotes();
		});
	} catch ( error ){
		// Show a modal with data in case the UI couldn't load
		handleFatalError({
			title:   escapeHTML( __( 'The recipe creator could not be loaded', 'uncanny-automator' ) ),
			warning: escapeHTML( __( 'Sorry, something went wrong when loading the recipe interface. Technical details are listed below.', 'uncanny-automator' ) ),
			content: escapeHTML( __( 'Click Learn More for steps you can take to resolve this issue.', 'uncanny-automator' ) ),
			console: error
		});
	}

	document.addEventListener( 
		'uap-builder-recipe-data-change', 
		event => {
			new Triggers();
			new Actions();
			new Publish();
		} 
	);

	// Remove the "Changes you made may not be saved" WordPress alert
	jQuery( document ).ready( () => {
		jQuery( window ).off( 'beforeunload.edit-post', null );
	});		
}